import uuid from 'uuid-random';
import { log } from 'log';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslations } from 'js/hooks/i18n';
import { validateGeolocation } from 'js/hooks/auth/pas';
import { useSmartClosePopups } from 'js/components/common/PopupManager';
import { publicEventsAPIService } from 'js/services/publicEventsAPI.service';

import { showGeoComplyPopupAction } from '../../../actions';

export const GEOCOMPLY_OOBEE_ERROR_POPUP_ID = uuid();

export const useOnOobeeError = ({ sdk, transactionID, setShowOverlay, useTransparentPopup }) => {
    const closePopups = useSmartClosePopups();
    const onRefresh = useCallback(() => window.location.reload(), []);
    const dispatch = useDispatch();
    const t = useTranslations();

    return useCallback(async (errorCode, message) => {
        publicEventsAPIService.trigger('geofencing-error', { transactionID, errorCode, message });

        log('gcErr', { transactionID, errorCode, message });

        switch (errorCode) {
            case sdk.ErrorCodes.LICENSE_REQUIRED:
            case sdk.ErrorCodes.APP_NOT_INSTALLED:
                // no need to report these errors to IMS yet
                return;
            default:
                setShowOverlay(false);

                dispatch(showGeoComplyPopupAction({
                    id: GEOCOMPLY_OOBEE_ERROR_POPUP_ID,
                    title: 'playtech.mobile.system.geocomply.popups.error.title',
                    content: t(`playtech.mobile.system.geocomply.popups.error.${errorCode}`, message),
                    isModal: true,
                    buttons: [
                        {
                            onClick: () => closePopups(GEOCOMPLY_OOBEE_ERROR_POPUP_ID),
                            text: 'playtech.mobile.system.geocomply.popups.error.ignore',
                            color: 'negative'
                        },
                        {
                            onClick: onRefresh,
                            text: 'playtech.mobile.system.geocomply.popups.error.refresh',
                            color: 'info'
                        }
                    ],
                    useTransparentPopup
                }));

                try {
                    await validateGeolocation(null, null, null, transactionID, errorCode, 'geocomply');
                } catch (e) {
                    // noop
                }
        }
    }, [
        t,
        sdk,
        onRefresh,
        closePopups,
        transactionID,
        dispatch,
        setShowOverlay,
        useTransparentPopup
    ]);
};
